import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { useSettingsContext } from '../contexts/settings';
import Tabs from './filters/Tabs';
import Search from './filters/Search';
import Select from './filters/Select';

interface IProps {
	children: React.ReactNode;
}

const FiltersBar = ({ children }: IProps) => {
	const { tax } = useFiltersContext();
	const settings = useSettingsContext();

	const taxEntries = Object.entries(tax);

	const [hideFilters, setHideFilters] = React.useState(false);

	const renderFilters = (postType: string) => {
		switch (postType) {
			case 'team_member': {
				const groupCategory = taxEntries.find(([key]) => key === 'group_category');
				const titleCategory = taxEntries.find(([key]) => key === 'title_category');

				return (
					<div className="pfa-filters-bar__filters">
						<div className="pfa-filters-bar__tabs">
							{groupCategory && (
								<Tabs
									taxonomy={groupCategory[1]}
									onTabChange={(option) => setHideFilters(!!option.hide_filters)}
								/>
							)}
						</div>
						{!hideFilters && (
							<div className="pfa-filters-bar__fields">
								<div className="pfa-filters-bar__select">
									{titleCategory && (
										<>
											<div className="pfa-filters__title">
												{titleCategory[1].labels.singular}
											</div>
											<Select taxonomy={titleCategory[1]} />
										</>
									)}
								</div>
								<div className="pfa-filters-bar__search">
									<Search />
								</div>
							</div>
						)}
					</div>
				);
			}
			default: {
				return <div className="pfa-filters-bar__filters">{children}</div>;
			}
		}
	};

	if (taxEntries.length || settings.showSearch) {
		return (
			<div className={`pfa-filters-bar pfa-filters-bar--${settings.postType}`}>
				{renderFilters(settings.postType)}
			</div>
		);
	}

	return <></>;
};

FiltersBar.displayName = 'FiltersBar';

export default FiltersBar;
